const data = {
    email: {
        subject: "Mars Rover Photo from Spacestagram",
        body: "Spacestagram showed me this cool Mars photo! Heres the link: "
    },
    facebook: {
        quote: "Mars Rover Photo from Spacestagram",
        hastag: "Spacestagram"
    },
    twitter: {
        title: "Mars Rover Photo from Spacestagram",
        hashtags: ["Spacetagram", "Mars"]
    }

}

export default data;